import { Table } from "react-bootstrap";
import { map } from "lodash";
import React from "react";
import { SelectionState, TParameterSelection } from "../../index";
import SelectedParametersItem from "./SelectedParametersItem";

interface Props {
  selection: SelectionState;
  onParameterRemove?: (item: TParameterSelection) => void;
}

const SelectedParametersList = (props: Props) => {
  const { selection, onParameterRemove } = props;
  const selectionCount = Object.keys(selection).length;
  const shouldRenderActionsColumn = Boolean(onParameterRemove);

  return (
    <Table striped bordered hover size="sm" className="selected-parameters-table">
      <thead>
        <tr>
          <th>Parameter</th>
          <th>Subset name</th>
          <th>Subset type</th>
          {
            shouldRenderActionsColumn &&
            <th></th>
          }
        </tr>
      </thead>
      <tbody>
        {
          selectionCount === 0 &&
          <tr>
            <td colSpan={10} className="empty-row">
              You have no selected parameters. Please, select up to 15 parameters.
            </td>
          </tr>
        }
        {
          map(
            selection,
            (s =>
              <SelectedParametersItem key={`${s.parameter.id}-${s.subset.id}`} item={s} onRemove={onParameterRemove} />
            )
          )
        }
      </tbody>
    </Table>
  )
}

export default SelectedParametersList;
